import './backdrop.css';
export default {
  "backdrop": "pf-v5-c-backdrop",
  "backdropOpen": "pf-v5-c-backdrop__open"
};